import { render, staticRenderFns } from "./P48.vue?vue&type=template&id=b9bba01c&scoped=true"
import script from "./P48.ts?vue&type=script&lang=ts&external"
export * from "./P48.ts?vue&type=script&lang=ts&external"
import style0 from "./P48.vue?vue&type=style&index=0&id=b9bba01c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9bba01c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src120839944/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b9bba01c')) {
      api.createRecord('b9bba01c', component.options)
    } else {
      api.reload('b9bba01c', component.options)
    }
    module.hot.accept("./P48.vue?vue&type=template&id=b9bba01c&scoped=true", function () {
      api.rerender('b9bba01c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/ProcessesForms/pages/P48/P48.vue"
export default component.exports